import React from "react";
import indoorbattery from "../images/indoorbattery.png";
import indoorunit from "../images/Indoorunit.png";
import SolarBattery from "../images/SolarBattery.jpeg";
import Extenal_solar_pannel from "../images/External_solar_pannel.jpeg";

export default function Gallery() {
  const items = [
    {
      src: SolarBattery,
      title: "Battery Storage Systems",
      desc: "Professional battery installations for energy storage",
    },
    {
      src: indoorunit,
      title: "Indoor Solar Systems",
      desc: "Clean and organized indoor installations",
    },
    {
      src: indoorbattery,
      title: "Advanced Battery Systems",
      desc: "High-capacity lithium battery installations",
    },
    {
      src: Extenal_solar_pannel,
      title: "Off-Grid Solutions",
      desc: "Rural and remote area installations",
    },
  ];

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <div className="section-header">
          <h2>Our Work</h2>
          <p className="section-subtitle">
            Professional installations and quality equipment
          </p>
        </div>
        <div className="gallery-grid">
          {items.map((item, idx) => (
            <div className="gallery-item" key={idx}>
              <img src={item.src} alt={item.title} />
              <div className="gallery-overlay">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
